/**
 * Partner-slider marquee enhancer.
 *
 * The CSS-only marquee (two copies, translateX(-50%)) is only seamless when
 * one logo set is at least as wide as the container — with few logos the
 * track runs out of content and the wrap reads as a snap back to the start.
 *
 * This clones the set until the track covers container + one set, then
 * switches the animation to a pixel-exact one-set offset (--setw), which is
 * seamless for ANY number of copies. The CSS fallback stays for no-JS.
 */
(function () {
	'use strict';

	function enhance(track) {
		var originals = Array.prototype.filter.call(track.children, function (el) {
			return !el.hasAttribute('aria-hidden');
		});
		if (!originals.length) return;

		var style  = getComputedStyle(originals[0]);
		var margin = parseFloat(style.marginRight) || 0;
		var setWidth = originals.reduce(function (w, el) {
			return w + el.getBoundingClientRect().width + margin;
		}, 0);
		if (!setWidth) return;

		var container = track.parentElement.getBoundingClientRect().width;
		var setsNeeded = Math.max(2, Math.ceil((container + setWidth) / setWidth));
		var setsHave   = Math.round(track.children.length / originals.length);

		for (var s = setsHave; s < setsNeeded; s++) {
			originals.forEach(function (el) {
				var clone = el.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				track.appendChild(clone);
			});
		}

		track.style.setProperty('--setw', setWidth + 'px');
		track.classList.add('is-marquee');
	}

	function run() {
		// Editor canvas renders the slider static — never enhance there.
		if (document.body.classList.contains('ibizz-editor-preview')) return;
		document.querySelectorAll('.Partner.Overview.slider .partnerSlider-track').forEach(enhance);
	}

	// After `load` so logo images have real widths; re-run on resize (extra
	// clones from a wider pass are harmless — only --setw must stay exact).
	window.addEventListener('load', run);

	var resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(run, 150);
	});
})();
